import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { BulletinBoardResponse } from '../../../common/validations'
import { useAPIGetBulletinBoardBulletins } from '../../api/apiHooks/useAPIGetBulletinBoardBulletins'

interface BulletinBoardDataLoaderProps {
  children: (props: {
    bulletins: BulletinBoardResponse['bulletins']
    onLoadMore: () => void
    hasNextPage: boolean
  }) => React.ReactNode
}

export const BulletinBoardDataLoader: React.FC<
  BulletinBoardDataLoaderProps
> = ({ children }) => {
  const { contractId } = useParams<{ contractId: string }>()

  const { bulletins, fetchNextPage, hasNextPage } =
    useAPIGetBulletinBoardBulletins({
      contractId: contractId!,
    })

  const handleLoadMore = useCallback(() => {
    fetchNextPage()
  }, [fetchNextPage])

  return children({
    bulletins,
    onLoadMore: handleLoadMore,
    hasNextPage,
  })
}
